(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-choice-button/assets/javascripts/pix-button.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-choice-button/assets/javascripts/pix-button.js');
"use strict";

const CouponChoiceButton = svs.components.tipsen.couponChoiceButton.CouponChoiceButton;
const PixButton = _ref => {
  let ariaControls = _ref.ariaControls,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    isShowingPix = _ref.isShowingPix;
  return React.createElement(CouponChoiceButton, {
    ariaControls: ariaControls,
    ariaLabel: "PIX - Fyll i kupong med hj\xE4lp av PIX",
    className: "coupon-toolbox-pix-button",
    icon: "pix",
    isAriaExpanded: isShowingPix,
    isDisabled: disabled,
    isSelected: isShowingPix,
    onClick: onClick
  }, "Fyll i med PIX!");
};
setGlobal('svs.components.tipsen.couponChoiceButton.PixButton', PixButton);

 })(window);